import axios from 'axios';

// export const API_BASE_URL = 'https://backend.interior.pinkmoontech.com';
// For production, use your subdomain or VPS IP
export const ONLYOFFICE_SERVER_URL = 'https://office.interior.pinkmoontech.com'; 
// export const ONLYOFFICE_SERVER_URL = 'http://YOUR_VPS_IP:9000';
//export const API_BASE_URL = 'http://127.0.0.1:5050';
export const API_BASE_URL = 'https://qa.backend.spacedesigns.pinkmoontech.com';
// export const API_BASE_URL = "https://qa.interior.backend.pinkmoontech.com";
// export const API_BASE_URL = "https://backend.interior.pinkmoontech.com";
const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('company_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  try {
    const user = JSON.parse(localStorage.getItem('company_user'));
    if (user && user.storeRef) {
      config.headers['X-Store-Ref'] = user.storeRef;
    }
  } catch(e) {}
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('company_token');
      localStorage.removeItem('company_user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;





